<script setup lang="ts">
import { ref } from 'vue'

import { Basketball3x3IncidentId } from '@collector/sportsapi-client-legacy'
import { useLiveViewBackground } from '@mobile/views/Relation/Shared/LiveView/useLiveViewBackground'
import PocketIncidents from '@mobile/views/Relation/Shared/PocketIncidents/PocketIncidents.vue'
import QueueBlockedOverlay from '@mobile/views/Relation/Shared/Popups/Queue/QueueBlockedOverlay.vue'
import { useEventInjections } from '@mobile/views/Relation/Shared/RelationDependencies/useEventInjections'
import { useSportConfiguration } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/useSportConfiguration'
import LiveViewCenterColumn from '@mobile/views/Relation/Sports/Basketball3x3/LiveView/LiveViewCenterColumn/LiveViewCenterColumn.vue'
import LiveViewHeader from '@mobile/views/Relation/Sports/Basketball3x3/LiveView/LiveViewHeader/LiveViewHeader.vue'
import LiveViewLeftColumn from '@mobile/views/Relation/Sports/Basketball3x3/LiveView/LiveViewLeftColumn/LiveViewLeftColumn.vue'
import LiveViewRightColumn from '@mobile/views/Relation/Sports/Basketball3x3/LiveView/LiveViewRightColumn/LiveViewRightColumn.vue'

const { probableEvent } = useEventInjections()
const isPocketIncidentsMenuExpanded = ref(false)
const { eventHeaderConfiguration } = useSportConfiguration()
const liveViewBackground = useLiveViewBackground(
  probableEvent,
  eventHeaderConfiguration,
)
</script>

<template>
  <div
    class="relative h-full overflow-hidden pt-1"
    :class="liveViewBackground"
  >
    <QueueBlockedOverlay />
    <div class="flex h-full flex-col">
      <LiveViewHeader />
      <div
        class="grid h-full gap-4 px-2 pt-1 pb-5 sm:overflow-y-auto"
        style="
          grid-template-columns: 0.4fr 0.2fr 1fr 0.2fr 0.4fr;
          grid-template-rows: 100%;
        "
      >
        <LiveViewLeftColumn />
        <LiveViewCenterColumn />
        <LiveViewRightColumn />
      </div>

      <PocketIncidents
        :isExpanded="isPocketIncidentsMenuExpanded"
        :incidentIds="[
          Basketball3x3IncidentId.Timeout,
          Basketball3x3IncidentId.Challenge,
          Basketball3x3IncidentId.BreakDuringTheGame,
          Basketball3x3IncidentId.Injury,
        ]"
        @toggle="isPocketIncidentsMenuExpanded = !isPocketIncidentsMenuExpanded"
        @incidentAddedToQueue="isPocketIncidentsMenuExpanded = false"
      />
    </div>
  </div>
</template>
